//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FilterSection } from '@components/media-filters/filterSectionModels';

export const OPEN_ENDED_THRESHOLD_SECONDS = 900;

export const VIDEO_DURATION_BREAKPOINTS = [
  0,
  5,
  15,
  30,
  60,
  120,
  300,
  OPEN_ENDED_THRESHOLD_SECONDS,
];

export const VIDEO_DURATION_TICK_LABELS = [
  '0s',
  '5s',
  '15s',
  '30s',
  '1m',
  '2m',
  '5m',
  '≥15m',
];

export const MAX_VIDEO_DURATION_INDEX = VIDEO_DURATION_BREAKPOINTS.length - 1;

export interface VideoDurationPreset {
  id: string;
  label: string;
  max: number;
  min: number;
}

export const VIDEO_DURATION_PRESETS: VideoDurationPreset[] = [
  { id: 'under-5s', label: '≤ 5s', min: 0, max: 5 },
  { id: '15-30s', label: '15–30s', min: 15, max: 30 },
  { id: '60s-plus', label: '≥ 60s', min: 60, max: OPEN_ENDED_THRESHOLD_SECONDS },
  { id: '2m-plus', label: '≥ 2m', min: 120, max: OPEN_ENDED_THRESHOLD_SECONDS },
];

export const DEFAULT_VIDEO_DURATION_FILTER_SECTION: FilterSection<string> = {
  options: [],
  paramKey: 'videoDuration',
};
